<mat-sidenav-container>

    <mat-sidenav #sidenav mode="side" opened class="filters">
        <app-find-route-form (selected)="handleFormSelected($event)" [patchRouteQuery]="editQuery$ | async"></app-find-route-form>
    </mat-sidenav>

    <mat-sidenav-content class="sidenav-content">
        <app-sidenav-toggle [sidenav]="sidenav"></app-sidenav-toggle>
        <div class="table-layout">
            <app-select-route-segment-form [routeQuery]="routeQuery"></app-select-route-segment-form>
        </div>

    </mat-sidenav-content>

</mat-sidenav-container>